module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0108.jpg?v=3c0e6d54";